import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import DiscountForm from '../components/forms/discount-form';

const DiscountsFormRoute: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const id = searchParams.get('id')
  return (
    <>
      <PageHeader
        title="فرم تخفیف"
        style={{ padding: " 16px 0" }}
        onBack={() => navigate(-1)}
        />
      <Card >
        <DiscountForm id={id} />
      </Card>
    </>
  );
}

export default DiscountsFormRoute;
